import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { confirmarResetPassword } from "../services/auth";
import "./Login.css";

const ConfirmarReset = () => {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [nueva, setNueva] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMensaje("");

    if (nueva !== confirmar) {
      return setError("Las contraseñas no coinciden.");
    }

    try {
      await confirmarResetPassword({ uid, token, new_password1: nueva, new_password2: confirmar });
      setMensaje("Contraseña actualizada correctamente.");
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setError("No se pudo actualizar la contraseña. El enlace puede haber expirado.");
    }
  };

  return (
    <div className="auth-container">
      <h2>Restablecer Contraseña</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Nueva Contraseña</label>
          <input type="password" value={nueva} onChange={(e) => setNueva(e.target.value)} required />
        </div>
        <div className="form-group">
          <label>Confirmar Nueva Contraseña</label>
          <input type="password" value={confirmar} onChange={(e) => setConfirmar(e.target.value)} required />
        </div>
        {mensaje && <p className="success-message">{mensaje}</p>}
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="auth-button">Actualizar Contraseña</button>
      </form>
    </div>
  );
};

export default ConfirmarReset;
